<template>
  <div class="exam-notes">
    <div v-if="introUrl">
      <p
        :style="`background: #fff url('${coverUrl}') no-repeat center / cover;`"
        class="banner"
        @click.stop="playVideo"><span class="play"></span>
      </p>
    </div>
    <p class="container" v-html="introContent" :style="{ height: introUrl ? '200px' : '350px' }"></p>
    <div class="btn-wrap">
      <a :disabled="!finish" :class="{'fill-btn': finish, 'btn-disabled': !finish }" @click="goTest">{{this.num != 0 ? this.num +' s' : '下一步'}}</a>
    </div>
    <a class="none" ref="signUpBtn"></a>
    <modal
      width="920px"
      speed="fast"
      no-footer
      enter-active-class="fadeIn"
      leave-active-class="fadeOut"
      :show.sync="showVideo">
      <video
        slot="content"
        ref="video"
        class="video"
        controls
        autoplay
        v-if="showVideo"
        @click="controlVideo"
        :src="introUrl"></video>
    </modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import { get } from '@/utils/ajax'

export default {
  components: {
    Modal
  },
  data () {
    return {
      finish: false,
      showVideo: false,
      introUrl: '',
      introContent: '',
      fixed: true,
      time: false,
      num: 5,
      coverUrl: ''
    }
  },
  mounted () {
    this.init()
    this.$store.dispatch('setMonitorReport', { type: 2 }) // 上报考试监控埋点，进入考试须知
  },
  methods: {
    async init () {
      let { exam_config } = this.$store.state.examConfig

      // 为了兼容从其他系统直接跳转过来拿不到数据的情况
      if (!exam_config) {
        const examId = this.$route.query.examId || localStorage.getItem('examId')
        try {
          const data = await get(`/home/exams/check/${examId}`) // 配置信息
          exam_config = data.exam_config
        } catch (e) {
          this.$router.push({ name: 'list' })
          return
        }
      }
      this.introContent = exam_config.find(item => item.label === 'LARGE_EXAM#exam_notice_content').actual_value
      this.introUrl = (exam_config.find(item => item.label === 'LARGE_EXAM#exam_notice_video_url') || {}).actual_value
      this.coverUrl = (exam_config.find(item => item.label === 'LARGE_EXAM#exam_notice_video_cover_url') || {}).actual_value
      if (this.introUrl) {
        setTimeout(() => {
          this.playVideo()
        }, 500)
      }
      this.timer = setInterval(() => {
        this.num -= 1
        if (this.num === 0) {
          clearInterval(this.timer)
          this.finish = true
        }
      }, 1000)
    },
    goTest () {
      if (!this.finish) return false
      this.$router.push({ name: 'pretest' })
    },
    // 打开视频弹框
    playVideo() {
      this.showVideo = true
    },
    // 控制video
    controlVideo() {
      const vid = this.$refs.video
      if (vid.paused) {
        vid.play()
      } else {
        vid.pause()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.exam-notes {
  position: relative;
  margin: 32px auto 0;
  width: 900px;
  // height: 1099px;
}
.none {
  position: absolute;
  bottom: 0;
}
.container {
  height: 200px;
  overflow: auto;
  background: #fafafa;
  // margin-bottom: 20px;
  padding: 20px;
}
.video {
  width: 100%;
}
.banner {
  position: relative;
  display: flex;
  height: 180px;
  justify-content: center;
  align-items: center;
  // background: url('~@/assets/images/identityCheck/banner.png') no-repeat center / cover;
  margin-bottom: 20px;
  border-radius: 6px;
  cursor: pointer;
  &::after {
    position: absolute;
    width: 100%;
    height: 100%;
    content: '';
    background: rgba(0, 0, 0, 0.3);
  }
  &:hover {
    span {
      transform: scale(1.1);
    }
  }
  span {
    position: relative;
    z-index: 1;
    transition: .5s;
    width: 48px;
    height: 49px;
    background: url('~@/assets/images/identityCheck/play.png') no-repeat center / cover;
  }
}
h3 {
  font-size: 20px;
  text-align: left;
  color: $titleColor;
  line-height: 22px;
  font-weight: 500;
  margin-bottom: 10px;
}
p {
  text-align: left;
  font-size: 14px;
  color: $titleColor;
  font-weight: 300;
  line-height: 28px;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.tip {
  color: #FF0000;
  font-size: 16px;
}
.btn-wrap {
  // width: 1400px;
  margin: auto;
  background: #fff;
  // position: fixed;
  // left: 50%;
  // bottom: 0;
}
.no-fiex {
  position: relative;
}
.fill-btn {
  display: inline-block;
  @include theme-fill-btn(144px, 42px, 16px, 4px);
  margin: 40px 0;
}
.btn-disabled {
  display: inline-block;
  @include theme-disable-btn(144px, 42px, 16px, 4px);
  margin: 40px 0;
}
</style>
